import { reactive, toRefs } from "vue";
import { connect, readContract, writeContract, getAccount, waitForTransactionReceipt, getBalance, watchChainId } from '@wagmi/core';
import { switchChain, disconnect, watchAccount, reconnect } from '@wagmi/core'
import { polygon } from '@wagmi/core/chains'

import Swal from "sweetalert2";
import { connectNativeWallet } from './useWalletAccount'
import { config } from './walletConfig'
import { abi } from './pcd_abi'

import { onMounted, onBeforeUnmount } from 'vue';

const addresses = require('./addresses');

// import RiceToken from "../../../build/contracts/RiceToken.json";

const USDT_DECIMALS = 6;

const state = reactive({
    currentAccount: "",
    balance: 0,
    investmentAmount: "",
    depositAmount: "",
    withdrawAmount: "",
    balanceOfShares: "",
    balanceOfAvailable: "",
    usdtBalance: "",
    withdrawableDividendAmount: 0,
    withdrawnDividendAmount: 0,
    usdtAllowance: 0,
    isApproved: false,
    isConnected: false,
    isCheckState: false,
    totalSharesForDividends: 0,
    ethBalance: '',
    contractsAddress: addresses.contractAddress,
    usdtAddress: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
});

import utils from './utils';
const { convertToWei, convertFromWei } = utils;

// import { web3modal } from './walletConfig';

const useWallet = () => {
    const connectWallet = async () => {
        try {

            // const provider = await web3modal.open();
            // console.log("provider:", provider);

            let result = await connectNativeWallet();
            console.log("连接钱包成功:", result);

            if (result) {
                if (result.chainId !== polygon.id) {
                    console.log("切换网络到 Polygon");
                    await switchChain(config, { chainId: polygon.id });
                }
                let account = getAccount(config);
                console.log("account:", account);

                if (account) {

                    state.accounts = account.addresses;
                    state.currentAccount = account.address;
                    state.isConnected = true;
                }

                await fetchContractData();

                Swal.fire({
                    title: '成功',
                    text: '钱包连接成功',
                    icon: 'success',
                    confirmButtonText: '确定',
                    timer: 1500,
                    timerProgressBar: true,
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
            }


        } catch (error) {
            console.error("连接钱包时发生错误:", error);
            Swal.fire({
                title: '错误',
                text: '连接钱包时发生错误: ' + error.message,
                icon: 'error',
                confirmButtonText: '确定',
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };


    const disconnectWallet = async () => {
        state.currentAccount = "";
        state.balance = 0;
        state.investmentAmount = "";
        state.depositAmount = "";
        state.withdrawAmount = "";
        state.balanceOfShares = "";
        state.balanceOfAvailable = "";
        state.usdtBalance = "";
        state.withdrawableDividendAmount = 0;
        state.withdrawnDividendAmount = 0;
        state.usdtAllowance = 0;
        state.isApproved = false;
        state.isConnected = false;
        state.totalSharesForDividends = 0;
        state.ethBalance = 0;

        await disconnect(config)
        console.log("钱包已断开");
    };

    const fetchContractData = async () => {
        console.log("fetchContractData");
        await fetchBalanceOf();
        await fetchBalanceOfShares();
        await fetchBalanceOfAvailable();
        await getUsdtBalance();
        await getWithdrawableDividend();
        await getWithdrawnDividends();
        await getUsdtAllowance();
        await checkApproval();
        await getTotalSharesForDividends();
        await getEthBalance();
    };



    const approveUsdt = async (amount) => {
        try {
            if (amount > 0) {
                const usdtAmount = convertToWei(amount, USDT_DECIMALS);
                const result = await writeContract(config, {
                    chainId: 137,
                    abi,
                    address: state.usdtAddress,
                    functionName: 'approve',
                    args: [state.contractsAddress, usdtAmount]
                });

                if (result) {
                    console.log("交易哈希:", result);
                    // 检查交易状态
                    await monitorTransaction(result);
                }

                Swal.fire({
                    title: "成功",
                    text: "USDT 授权成功", 
                    icon: "success",
                    confirmButtonText: "确定",
                    timer: 1500,
                    timerProgressBar: true,
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });

            } else {
                Swal.fire({
                    title: "错误",
                    text: "请输入需要投资的数量",
                    icon: "warning",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
            }
        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "USDT 授权时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const setTokenPrice = async (newPrice) => {
        try {
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'setTokenPrice',
                args: [newPrice]
            });

            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

            Swal.fire({
                title: "成功", 
                text: "Token价格设置成功",
                icon: "success",
                confirmButtonText: "确定",
                timer: 1500,
                timerProgressBar: true,
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });

        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "设置Token价格时发生错误: " + error.message,
                icon: "error", 
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };


    const investInRice = async (amount) => {
        try {
            const usdtAmount = convertToWei(amount, USDT_DECIMALS);
            if (state.usdtAllowance < usdtAmount) {
                Swal.fire({
                    title: "错误",
                    text: "USDT 授权数量不足，请先授权。",
                    icon: "error",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
                return;
            }
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'invest',
                args: [usdtAmount.toString()]
            });

            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

            Swal.fire({
                title: "成功",
                text: "投资成功",
                icon: "success",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });

        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "投资时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const receiveDividends = async (amount) => {
        try {
            const usdtAmount = convertToWei(amount, USDT_DECIMALS);
            if (state.usdtAllowance < usdtAmount) {
                Swal.fire({
                    title: "错误",
                    text: "USDT 授权数量不足，请先授权。",
                    icon: "error",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
                return;
            }
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'receiveDividends',
                args: [usdtAmount.toString()]
            });

            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

            Swal.fire({
                title: "成功",
                text: "分红已成功接收",
                icon: "success",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });

        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "接受分红时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const distributeUndistributedDividends = async () => {
        try {
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'distributeUndistributedDividends',
                args: []
            });

            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

            Swal.fire({
                title: "成功",
                text: "未分配的分红已成功分配",
                icon: "success",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });

        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "分配未分配的分红时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const checkApproval = async () => {
        try {
            const usdtAmount = convertToWei(state.investmentAmount, USDT_DECIMALS);// BigInt(state.investmentAmount) * BigInt(10 ** USDT_DECIMALS);
            state.isApproved = state.usdtAllowance >= usdtAmount;
        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "检查授权时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const claimDividends = async () => {
        try {
            if (state.withdrawableDividendAmount <= 0) {
                Swal.fire({
                    title: "错误",
                    text: "没有可领取的分红",
                    icon: "error",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
                return;
            }


            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'claimDividends',
                args: []
            });

            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

            Swal.fire({
                title: "成功",
                text: "分红已领取",
                icon: "success",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        } catch (error) {
            Swal.fire({
                title: "错误",
                text: "领取分红时发生错误: " + error.message,
                icon: "error",
                confirmButtonText: "确定",
                width: '280px',
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const depositTokens = async () => {
        try {
            //state.balanceOfAvailable
            if (Number(state.depositAmount) > Number(state.balanceOfAvailable)) {
                Swal.fire({
                    title: "错误",
                    text: `没有足够的余额: ${state.depositAmount} > ${state.balanceOfAvailable}`,
                    icon: "error",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
                return;
            }

            const amountInWei = convertToWei(state.depositAmount);// Number(state.depositAmount) * Number(10 ** 18);
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'deposit',
                args: [amountInWei]
            });

            console.log("写入合约成功:", result);

            // 可以根据result对象中的信息进行后续处理
            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }


        } catch (error) {
            console.error("质押时发生错误:", error);
        }
    };

    const withdrawTokens = async () => {
        try {
            //state.balanceOfShares
            if ( Number(state.withdrawAmount) > Number(state.balanceOfShares) ) {
                Swal.fire({
                    title: "错误",
                    text: "没有足够的余额",
                    icon: "error",
                    confirmButtonText: "确定",
                    width: '280px',
                    background: '#111',
                    color: '#fff',
                    confirmButtonColor: '#10b981',
                });
                return;
            }

            const amountInWei = convertToWei(state.withdrawAmount);// Number(state.withdrawAmount) * Number(10 ** 18);
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'withdraw',
                args: [amountInWei]
            });

            console.log("写入合约成功:", result);

            // 可以根据result对象中的信息进行后续处理
            if (result) {
                console.log("交易哈希:", result);
                // 检查交易状态
                await monitorTransaction(result);
            }

        } catch (error) {
            console.error("提现时发生错误:", error);
        }
    };

    const getUsdtAllowance = async () => {
        try {
            const allowance = await readContract(config, {
                abi,
                address: state.usdtAddress,
                functionName: 'allowance',
                args: [state.currentAccount, state.contractsAddress]
            });
            console.log("allowance:", allowance);
            state.usdtAllowance = BigInt(allowance);
        } catch (error) {
            console.error("获取 USDT 授权数量时发生错误:", error);
        }
    };

    const fetchBalanceOf = async () => {
        try {
            const balance = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'balanceOf',
                args: [state.currentAccount]
            });
            console.log("balance:", balance);
            state.balance = convertFromWei(balance,18,2); // (Number(balance) / 10 ** 18).toFixed(2);
        } catch (error) {
            console.error("查询质押余额时发生错误:", error);
        }
    };


    const fetchBalanceOfShares = async () => {
        try {
            const balance = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'balanceOfShares',
                args: [state.currentAccount]
            });
            console.log("balanceOfShares:", balance);
            state.balanceOfShares = convertFromWei(balance,18,2);// (Number(balance) / 10 ** 18).toFixed(2);
        } catch (error) {
            console.error("查询质押余额时发生错误:", error);
        }
    };

    const fetchBalanceOfAvailable = async () => {
        try {
            const balance = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'balanceOfAvailable',
                args: [state.currentAccount]
            });
            console.log("balanceOfAvailable:", balance);
            state.balanceOfAvailable = convertFromWei(balance,18,2);// (Number(balance) / 10 ** 18).toFixed(2);
        } catch (error) {
            console.error("查询可用余额时发生错误:", error);
        }
    };

    const getUsdtBalance = async () => {
        try {

            const balance = await readContract(config, {
                abi,
                address: state.usdtAddress,
                functionName: 'balanceOf',
                args: [state.currentAccount]
            });
            console.log("usdtBalance:", balance);
            state.usdtBalance = convertFromWei(balance,USDT_DECIMALS,2);// (Number(balance) / Math.pow(10, Number(USDT_DECIMALS))).toFixed(2);

            await checkApproval();
        } catch (error) {
            console.error("获取 USDT 余额时发生错误:", error);
        }
    };

    const getEthBalance = async () => {
        try {
            const result = await getBalance(config, {
                address: state.currentAccount,
            });

            console.log("ETH Balance:", result);
            state.ethBalance = convertFromWei(result.value);//(Number(result.value) / Math.pow(10, 18)).toFixed(6);
        } catch (error) {
            console.error("获取 ETH 余额时发生错误:", error);
        }
    };

    const getWithdrawableDividend = async () => {
        try {
            const withdrawableDividend = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'dividendOf',
                args: [state.currentAccount]
            });
            console.log("withdrawableDividend:", withdrawableDividend);
            state.withdrawableDividendAmount = convertFromWei(withdrawableDividend,USDT_DECIMALS,2);// (Number(withdrawableDividend) / 10 ** USDT_DECIMALS).toFixed(2);
        } catch (error) {
            console.error("获取当前可领取的分红金额时发生错误:", error);
        }
    };

    const getWithdrawnDividends = async () => {
        try {
            const withdrawnDividend = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'accumulativeDividendOf',
                args: [state.currentAccount]
            });
            console.log("withdrawnDividend:", withdrawnDividend);
            console.log("withdrawableDividendAmount:", state.withdrawableDividendAmount);
            // state.withdrawnDividendAmount =  (Number(convertFromWei(withdrawnDividend)) - state.withdrawableDividendAmount).toFixed(2);

            state.withdrawnDividendAmount = Math.max(0, (Number(convertFromWei(withdrawnDividend,USDT_DECIMALS,2)) - state.withdrawableDividendAmount)).toFixed(2);

        } catch (error) {
            console.error("获取已经领取的分红金额时发生错误:", error);
        }
    };

    const getTotalSharesForDividends = async () => {
        try {
            const totalShares = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'getTotalSharesForDividends',
                args: []
            });
            console.log("totalSharesForDividends:", totalShares);
            state.totalSharesForDividends = convertFromWei(totalShares);// (Number(totalShares) / 10 ** 18).toFixed(2);
        } catch (error) {
            console.error("获取分红总股份时发生错误:", error);
        }
    };

    const getTokenPrice = async () => {
        try {
            const price = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'tokenPrice',
                args: []
            });
            console.log("Token价格:", price);
            state.tokenPrice = convertFromWei(price, USDT_DECIMALS, 2);
        } catch (error) {
            console.error("获取Token价格时发生错误:", error);
        }
    };

    const monitorTransaction = async (txHash) => {
        try {
            state.isCheckState = true;
            const receipt = await waitForTransactionReceipt(config, {
                hash: txHash,
            });

            if (receipt && receipt.status === "success") {
                console.log("交易成功:", receipt);
                // 处理成功的交易
                await fetchContractData();
            } else {
                console.log("交易失败:", receipt);
                // 处理失败的交易
            }
        } catch (error) {
            console.error("监控交易时发生错误:", error);
        } finally {
            console.log("交易结束");
            state.isCheckState = false;
        }
    };


    const watchChain = () => {
        const unwatch = watchChainId(config, {
            onChange(chainId) {
                console.log('Chain ID changed!', chainId);
                // Perform any actions you need when the chain ID changes
            },
        });

        return unwatch;
    };

    // const fetchAccountData = async () => {
    //     try {
    //         const account = getAccount(config);
    //         if (account) {
    //             state.currentAccount = account.address;
    //             state.isConnected = true;

    //             // Fetch other contract data as needed
    //             await fetchContractData();

    //             Swal.fire({
    //                 title: '成功',
    //                 text: '钱包连接成功',
    //                 icon: 'success',
    //                 confirmButtonText: '确定',
    //                 timer: 1500,
    //                 timerProgressBar: true,
    //             });
    //         }
    //     } catch (error) {
    //         console.error("获取账户数据时发生错误:", error);
    //         Swal.fire({
    //             title: '错误',
    //             text: '获取账户数据时发生错误: ' + error.message,
    //             icon: 'error',
    //             confirmButtonText: '确定',
    //         });
    //     }
    // };

    const privateInvest = async (amount) => {
        try {
            const usdtAmount = convertToWei(amount, USDT_DECIMALS);
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'privateInvest',
                args: [usdtAmount.toString()]
            });
    
            if (result) {
                await monitorTransaction(result);
            }
    
            Swal.fire({
                title: "成功",
                text: "私募投資成功",
                icon: "success",
                confirmButtonText: "確定",
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        } catch (error) {
            Swal.fire({
                title: "錯誤",
                text: "私募投資失敗: " + error.message,
                icon: "error",
                confirmButtonText: "確定",
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const setPrivateInvestor = async (address, enabled) => {
        try {
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'setPrivateInvestor',
                args: [address, enabled]
            });
    
            if (result) {
                await monitorTransaction(result);
            }
    
            Swal.fire({
                title: "成功",
                text: `地址 ${enabled ? "已啟用" : "已停用"} 私募權限`,
                icon: "success",
                confirmButtonText: "確定",
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
    
        } catch (error) {
            Swal.fire({
                title: "錯誤",
                text: "設定私募地址失敗: " + error.message,
                icon: "error",
                confirmButtonText: "確定",
                background: '#111',
                color: '#fff',
                confirmButtonColor: '#10b981',
            });
        }
    };

    const isPrivateInvestor = async (address) => {
        try {
            const result = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'isPrivateInvestor',
                args: [address]
            });
    
            return result;
        } catch (error) {
            console.error("查詢私募地址狀態失敗:", error);
            return false;
        }
    };

    const pauseContract = async () => {
        try {
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'pause',
                args: []
            });
            await monitorTransaction(result);
            Swal.fire({ title: "已暫停", text: "合約已進入暫停狀態", icon: "info" });
        } catch (err) {
            console.error("暫停失敗:", err);
        }
    };
    
    const unpauseContract = async () => {
        try {
            const result = await writeContract(config, {
                chainId: 137,
                abi,
                address: state.contractsAddress,
                functionName: 'unpause',
                args: []
            });
            await monitorTransaction(result);
            Swal.fire({ title: "已啟用", text: "合約已恢復正常", icon: "success" });
        } catch (err) {
            console.error("啟用失敗:", err);
        }
    };

    const isPaused = async () => {
        try {
            const result = await readContract(config, {
                abi,
                address: state.contractsAddress,
                functionName: 'paused',
                args: []
            });
    
            return result;
        } catch (error) {
            console.error("讀取 paused 狀態失敗:", error);
            return false;
        }
    };


    onMounted(async () => {
        console.log("onMounted-useWallet");
        try {
            const account = getAccount(config);
            if (account && account.isConnected) {
                console.log("account:", account);
                state.currentAccount = account.address;
                state.isConnected = true;
                fetchContractData();
            }

            if(account && account.status=='connecting'){
                console.log('connecting');
                const result = await reconnect(config, {
                    connectors: config.connectors,
                });
                console.log("reconnect:", result);
            }

        } catch (error) {
            console.error("获取账户数据时发生错误:", error);
        }

        // const unwatchChain = watchChain();

        const unwatchAccount = watchAccount(config, {
            async onChange(data) {
                console.log('Account changed!', data);


                if (data.isConnected) {
                    console.log("isConnected1:", data.isConnected);
                    state.currentAccount = data.address;
                    state.isConnected = true;
                    await fetchContractData();
                } else {
                    console.log("isConnected2:", data.isConnected);
                    state.currentAccount = "";
                    state.balance = 0;
                    state.investmentAmount = "";
                    state.depositAmount = "";
                    state.withdrawAmount = "";
                    state.balanceOfShares = "";
                    state.balanceOfAvailable = "";
                    state.usdtBalance = "";
                    state.withdrawableDividendAmount = 0;
                    state.withdrawnDividendAmount = 0;
                    state.usdtAllowance = 0;
                    state.isApproved = false;
                    state.isConnected = false;
                    state.totalSharesForDividends = 0;
                    state.ethBalance = 0;
                }

            },
        })

        onBeforeUnmount(async () => {
            // unwatchChain();
            unwatchAccount();

            console.log("onBeforeUnmount-useWallet");
            // await disconnect(config);
        });

    });



    return {
        ...toRefs(state),
        connectWallet,
        disconnectWallet,
        approveUsdt,
        investInRice,
        checkApproval,
        claimDividends,
        depositTokens,
        withdrawTokens,
        getTotalSharesForDividends,
        getEthBalance,
        watchChain,
        setTokenPrice,
        getTokenPrice,
        receiveDividends,
        distributeUndistributedDividends,
        privateInvest,
        setPrivateInvestor,
        isPrivateInvestor,
        pauseContract,
        unpauseContract,
        isPaused
    };
};

export default useWallet;
